import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: any = {
  loading: false,
  error: null,
  users: [],
  customers: [],
  storeUser: [],
  storeRoles: null,
};

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    loadUsersRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadUsersSuccess(state, action: any) {
      state.loading = false;
      state.error = null;
      state.users = action?.payload?.result?.results;
      state.paginationOption = { 
        page: action.payload?.result?.page,
        pageSize: action.payload?.result?.pageSize,
        totalItems: action.payload?.result?.totalItems,
        numberOfPages: action.payload?.result?.numberOfPages,
      };
    },
    loadUsersFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    loadCustomersRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadCustomersSuccess(state, action: any) {
      state.loading = false;
      state.error = null;
      state.customers = action?.payload?.results;
      state.paginationOption = {
        page: action.payload?.page,
        pageSize: action.payload?.pageSize,
        totalItems: action.payload?.totalItems,
        numberOfPages: action.payload?.numberOfPages,
      };
    },
    loadCustomersFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    loadSingleCustomerRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadSingleCustomerSuccess(state, action: any) {
      state.loading = false;
      state.error = null;
      state.singlecustomer = action?.payload?.result;
    },
    loadSingleCustomerFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    //store user
    storeUsersRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    storeUsersSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.storeUsers = action.payload;
    },
    storeUsersFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    // assign role to the user

    storeAssignRoleRequested(
      state,
      action: PayloadAction<{ userId: number; roleId: number[] }>
    ) {
      state.loading = true;
      state.error = null;
    },
    storeAssignRoleSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.storeRoles = action.payload;
    },
    storeAssignRoleFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    // store user
    storeUserRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    storeUserSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.storeUser = action.payload;
    },
    storeUserFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
    deleteUserRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    deleteUserSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.deleteUser = action.payload;
    },
    deleteUserFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  storeUsersRequested,
  storeUsersSuccess,
  storeUsersFail,
  loadUsersRequested,
  loadUsersSuccess,
  loadUsersFail,
  storeAssignRoleRequested,
  storeAssignRoleSuccess,
  storeAssignRoleFail,
  storeUserFail,
  storeUserRequested,
  storeUserSuccess,
  loadCustomersRequested,
  loadCustomersFail,
  loadCustomersSuccess,
  loadSingleCustomerRequested,
  loadSingleCustomerFail,
  loadSingleCustomerSuccess,
  deleteUserRequested,
  deleteUserSuccess,
  deleteUserFail,
} = usersSlice.actions;

export default usersSlice.reducer;
